import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div>
        <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 flex items-center gap-2">
          <span className="w-1.5 h-6 rounded-full bg-accent-500" aria-hidden="true" />
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg" aria-hidden="true" />
        </Link>
      )}
    </div>
  );
}